import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";


export default function Russia() {
    const Navigate = useNavigate()
  return (
    <div className="vbgy">
      <div className="dfhtu"><h2>MBBS in Russia</h2></div>
            <div className="wityu" >
                
            <img src="https://itcslimited.com/wp-content/uploads/2021/06/blog-oldest-medical-russia-banner.jpg"></img>
            
                                <p>
                                    Russia is known worldwide for its academic excellence in higher
                                    studies. over 2 million students are enrolled in Russian
                                    Universities and institutes.Nearly 875000 science students and over
                                    tutes These students actively participate in exploring advanced
                                    technology and new scientific methods Russian medical institutes are
                                    well equipped with advanced technologies and adopt latest teaching
                                    methods. The Medical degrees granted by Russian medical colleges
                                    have grapped nearly 30 top position within the world ranking.<br/><br/>
                                    <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
                                </p>
                                
                        
            </div>

    {/* 00000000000000000000000000000000000000000000000000000 */}

       <div className="nffd">

                <img src="https://www.7skyconsultancy.com/assets/images/Russia.png"></img>
                <div className="nhjip">
                        
                        <h3 style={{backgroundColor:"#ff9818", padding:"10px", borderRadius:"10px"}}>A BRIEF LOOK AT MBBS In RUSSIA</h3>
                        <br/>
                        <br/>
                        <table className="ewrfd">
                        
                            <tr>
                                <td>Capital</td>
                                <td>Moscow</td>
                            </tr>
                            <tr>
                                <td>Population</td>
                                <td>14.41 crore(2020)</td>
                            </tr>
                            <tr>
                                <td>Medium of Instruction</td>
                                <td>English</td>
                            </tr>
                            <tr>
                                <td>Currency</td>
                                <td>Russian Ruble(1 Lari= 1.37 inr)</td>
                            </tr>
                            <tr>
                                <td>International Airport</td>
                                <td>Moscow</td>
                            </tr>
                            <tr>
                                <td>Recognition</td>
                                <td>NMC (MCI), WHO, ECFMG, FAIMER, WDOMS</td>
                            </tr>
                            <tr>
                                <td>Course Duration</td>
                                <td>6 Years(5 + 1 Year's internship)</td>
                            </tr>
                            <tr>
                                <td>Average cost of stay (Fee included)</td>
                                <td>20-25 lakhs(Approx)</td>
                            </tr>
                            </table>

                </div>

       </div>  

       {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
        <div className="cxdsf">
       <div className="ugvuids">
            <h2>UNIVERSITY OF RUSSIA</h2>
            <table className="table" data-aos="zoom-in-up" data-aos-duration="1000" data-aos-easing="linear">
                <tr>
                    <th className="th title2">UNIVERSITY NAME</th>
                    <th className="th title2">TUTION FEE</th>
                    <th className="th title2">HOSTAL FEE(RUB)</th>
                    <th className="th title2">OTC</th>
                    <th className="th title2">INCENTIVE</th>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>1.</span>Altai State Medical University</td>
                    <td className="td">3,23,600 </td>
                    <td className="td">35,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1200$</td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>2.</span>Bashkir State Medical University</td>
                    <td className="td">2,94,120</td>
                    <td className="td">13,000</td>
                    <td className="td">2300$</td>
                    <td className="td">1200$</td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>3.</span>Chuvash State University</td>
                    <td className="td">2,35,000</td>
                    <td className="td">56,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
               
                    <tr>
                    <td className="td dflex dflexMob"><span>4.</span>	Crimean Federal Medical University</td>
                    <td className="td">2,50,000</td>
                    <td className="td">9,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                
                    <tr>
                    <td className="td dflex dflexMob"><span>5.</span>	First Moscow State Medical University</td>
                    <td className="td">11,800$</td>
                    <td className="td">2400$</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                
                    <tr>
                    <td className="td dflex dflexMob"><span>6.</span>	For Eastern Medical University</td>
                    <td className="td">3,90,000</td>
                    <td className="td">40,000</td>
                    <td className="td">2500$</td>
                    <td className="td">700$ </td>
                </tr>
                
                
                    <tr>
                    <td className="td dflex dflexMob"><span>7.</span>	Kazan Federal University </td>
                    <td className="td">4,68,000</td>
                    <td className="td">25,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                
                    <tr>
                    <td className="td dflex dflexMob"><span>8. </span>	Kazan State Medical University</td>
                    <td className="td">4,16,000</td>
                    <td className="td">18,000$</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>9. </span> Kuban State Medical University</td>
                    <td className="td">2,33,000</td>
                    <td className="td">21,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
               
                <tr>
                    <td className="td dflex dflexMob"><span>10. </span>Kursk State Medical University </td>
                    <td className="td">5500$</td>
                    <td className="td">1000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>11.</span>Mari State  University</td>
                    <td className="td">4000$</td>
                    <td className="td">500$</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>12</span>Orenburg State Medical University </td>
                    <td className="td">3200$</td>
                    <td className="td">600$</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>13 </span>Peoples Friendship  University</td>
                    <td className="td">10,000$</td>
                    <td className="td">1500$</td>
                    <td className="td">3500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>14. </span>Perm State Medical University </td>
                    <td className="td">2,70,000</td>
                    <td className="td">25000</td>
                    <td className="td">2400$</td>
                   
                    <td className="td">900$  </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>15. </span>Pirogrod Russian National Research Medical University</td>
                    <td className="td">5,00,000</td>
                    <td className="td">35,000</td>
                    <td className="td">2300$</td>
                    <td className="td">800$</td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>16. </span> Rostov State Medical University </td>
                    <td className="td">4000$</td>
                    <td className="td">800$</td>
                    <td className="td">2500$</td>
                    <td className="td">700$ </td>
                </tr>
               
                    <tr>
                    <td className="td dflex dflexMob"><span>17. </span>Saint Petersburg State Medical Universityy</td>
                    <td className="td">3,46,500</td>
                    <td className="td">35,000</td>
                    <td className="td">2400$</td>
                    <td className="td">900$ </td>
                </tr>
               
                    <tr>
                    <td className="td dflex dflexMob"><span>18. </span>Smolensk State Medical University</td>
                    <td className="td">5500$</td>
                    <td className="td">750$</td>
                    <td className="td">2000$</td>
                   <td className="td">700$ </td>
                </tr>
                
                    <tr>
                    <td className="td dflex dflexMob"><span>19. </span>Tver State Medical University</td>
                    <td className="td">2,62,760 </td>
                    <td className="td">25,000</td>
                    <td className="td">2500$</td>
                  <td className="td"> 1000$</td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>20. </span>Volgograd State Medical University</td>
                    <td className="td"> 4,28,000</td>
                    <td className="td">38,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>21. </span>Siberian State Medical University</td>
                    <td className="td">3,40,130</td>
                    <td className="td">60,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>22. </span>South Ural State Medical University</td>
                    <td className="td">2,34,000</td>
                    <td className="td">16,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
               
                <tr>
                    <td className="td dflex dflexMob"><span>23. </span>Kemerovo State University</td>
                    <td className="td">1,72,000</td>
                    <td className="td">9,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
               
                <tr>
                    <td className="td dflex dflexMob"><span>24. </span>Kemerovo State Medical University</td>
                    <td className="td">2,28,000</td>
                    <td className="td">12,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>25. </span>Kabardino Balkarian State Medical University</td>
                    <td className="td">1,90,000</td>
                    <td className="td">18,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
                
                <tr>
                    <td className="td dflex dflexMob"><span>26. </span>North Caucasian State Medical Academy</td>
                    <td className="td">2,80,000</td>
                    <td className="td">30,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$</td>
                </tr>
               
                <tr>
                    <td className="td dflex dflexMob"><span>27. </span>Orel State Medical University</td>
                    <td className="td">2,60,000</td>
                    <td className="td">20,000</td>
                    <td className="td">3000$</td>
                    <td className="td">1000$ </td>
                </tr>
               
                <tr>
                    <td className="td dflex dflexMob"><span>28. </span>Samara State Medical University</td>
                    <td className="td">3,20,000</td>
                    <td className="td">30,000</td>
                    <td className="td">2500$</td>
                    <td className="td">1000$ </td>
                </tr>
            </table>

       </div>
       </div>
       <section className="ugvui">
            <ul>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear">Above Mentioned Tution Fee Changable According to Their Academic Session.</li>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear">Admission Fee, Documentation & VISA Processing Excluded in Package.</li>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear">Form 2nd to 6th year's Medical Insurance & VISA Extension will be Extra.</li>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear">Flight Ticket Charge Excluded.</li>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear"><span><b>Note:</b></span><br/>In certain case students have to pay either partial or full amount of tuition fee to the university soon after receive letter, as per the University instruction</li>
            </ul>
        </section>



       {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}


       <div className="gsfas">
       <h3>BASHKIR STATE MEDICAL UNIVERSITY</h3>
                        
                        <div className="sdgdfghf">
                        <img src="https://www.metaeducationindia.com/wp-content/uploads/2021/02/Bashkir-state-medical-university.jpg"></img>
                                <p>
                                Bashkir State Medical University was established in 1932. It is one of the leading medical universities in the Russian Federation. With more than 8000 students from 40 different countries, it is the most suitable choice for MBBS in Russia.
                                Formerly introduced as Bashkortostan Institute in Ufa, Bashkir State Medical University is the top institution in the center of the medical and pharmaceutical sciences of the Republic of Bashkortostan.

                                <br/>
                                <strong>pESTO. : 1932</strong><br/>
                                <strong>University Type : Government</strong><br/>
                                <strong>Medium : English</strong><br/>
                                <strong>ESTO. : No. of Indian Students : 500+</strong><br/>
                                </p>
                                
                        </div>
                        
            </div>

            {/* 0000000000000000000000000000000000000000000000000 */}


            <div className="packageForFirstYear" >
                
                
                <table className="table fgjhfghfg" border="1">
                    <h2 style={{textAlign:"center", width:"100%"}}>PACKAGE FOR 1ST YEAR STUDENT</h2>
                    <thead>
                    <tr rules="rows">
                        <td >TUITION FEE</td>
                        <td >HOSTEL FEE</td>
                        <td >IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE & MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT ETC</td>
                        <td >INCENTIVE</td>
                    </tr>
                    
                    <tr> 
                        <td >2.94,120RUB</td>
                        <td >13,00RUB</td>
                        <td >2300$</td>
                        <td >1000$</td>
                    </tr>
                    </thead>
                    
                </table>
                <p className="para border">FOOD FEE PER MONTH - 120$</p>
                <p className="para border pb0">ADMISSION FEE, VISA PROCESSING & DOCUMENTATION ( 25-35000) | FLIGHT TICKET AS PER ACTUAL.</p>
            </div>

            {/* 000000000000000000000000000000000000000000000000000000000000000 */}


            <div className="packageForSixYear" data-aos="zoom-out" data-aos-duration="1000"  data-aos-easing="linear">
                <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
                <table className="table">
                <tr>
                    <th className="th title2">Package</th>
                    <th className="th title2">2nd</th>
                    <th className="th title2">3rd</th>
                    <th className="th title2">4th</th>
                    <th className="th title2">5th</th>
                    <th className="th title2">6th</th>
                </tr>
         
                <tr>
                    <td className="td ">Tuition Fee</td>
                    <td className="td">2,94,120RUB</td>
                    <td className="td">2,94,120RUB</td>
                    <td className="td">2,94,120RUB</td>
                    <td className="td">2,94,120RUB</td>
                    <td className="td">2,94,120RUB</td>
                </tr>
              
                <tr>
                    <td className="td">Hostel Fee</td>
                    <td className="td">13,000RUB</td>
                    <td className="td">13,000RUB</td>
                    <td className="td">13,000RUB</td>
                    <td className="td">13,000RUB</td>
                    <td className="td">13,000RUB</td>
                </tr>
                 
                 <tr>
                    <td className="td">Medical Insurance VISA Extention</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                </tr>
                
            </table>
        </div>

        <div className="mainSec">
            <ul>
                <li className="para"><span> IMPORTANT NOTE <b>:</b></span><br/><br/>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    BSMU has a huge clinic where over 24000 patients visit annually which helps students to be in practical touch.  <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">   
                    Bashkir State Medical University provides Simulation Based Training in the Simulation Centre.<br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    The University provides Russian language training for bilingual coaching.<br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    University has a diverse culture with 8000 foreign students coming from 40 different countries.  <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    There are fully equipped laboratories with modern equipment.
                    </p>
                    
                </li>
            </ul>
        </div>

    </div>
  );
}
